import {createElement} from 'rlink-react';
import {FormattedMessage} from 'react-intl';

export const DOW = <FormattedMessage
  id="term.DOW"
  defaultMessage="Dawn of War"
  description="The title of the franchise." />;

export const SITE_DESCRIPTION = <FormattedMessage
  id="ui.text.info.HOME_PAGE_DESCRIPTION"
  defaultMessage="Dawn of War 3 Official Site"
  description="Description of the home page." />;

export const FB_APPID = '1290376697659159';



// WEBPACK FOOTER //
// ./apps/www.dawnofwar.com/src/terms.jsx